
import { Component, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MbscModule } from '@mobiscroll/angular';
import { HeaderComponent } from "./components/shared/header/header.component";
import { MenuSidebarComponent } from './components/shared/sidebar/menu/sidebar/menuSidebar.component';
import { SpinnerComponent } from '@coreui/angular-pro';
import { SvgIconService } from './services/shared/icons/svg-icon.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { CalendarAdminComponent } from './components/admin/calendar-admin/calendar-admin.component';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [RouterOutlet, MbscModule, HeaderComponent, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  @ViewChild('headerRef') headerComponent!: HeaderComponent;
  isOverlayVisible = false;
  isLoading = false;
  title = 'calendar';
  toggleSideBar: boolean = false

  constructor(private router: Router, public svgIconService: SvgIconService, public http: HttpClient, private sanitizer: DomSanitizer) {}

  isLoginRoute(): boolean {
    return this.router.url === '/login';
  }

  toggleSidebar() {
    this.toggleSideBar = !this.toggleSideBar;
  }

  closeSidebar() {
    this.toggleSideBar = false;
  }

  openSidebar() {
    this.toggleSideBar = true;
  }

  ngOnInit(): void {
        //Icons laden
    Object.entries(this.svgIconService.svgUrls).forEach(([key, url]) => {
    this.http.get(url, { responseType: 'text' }).subscribe(svg => {
      this.svgIconService.svgCache[key] =
        this.sanitizer.bypassSecurityTrustHtml(svg);
      });
    });

    const closeColumnMarking = localStorage.getItem('closeColumnMarking');
    if (!closeColumnMarking) {
     localStorage.setItem('closeColumnMarking', JSON.stringify("Enter"))
    }
  }

onOverlayToggle(show: boolean): void {
  this.isOverlayVisible = show;

  if (!show && this.headerComponent) {
    this.headerComponent.closeEventList(false);
  }
}

onSetLoading(loading: boolean): void {
  this.isLoading = loading;
}

@ViewChild(RouterOutlet)
outlet!: RouterOutlet;

  onHeaderEventErrorFilter(event: any){
    const filterIds = event.filterIds;
    const filterName = event.filterName;
    const component = this.outlet?.component;
    if (component instanceof CalendarAdminComponent) {
      component.filterMyEventsByError(filterIds, filterName);
    }
  }

  resetErrorFilter(){
    const component = this.outlet?.component;
    if (component instanceof CalendarAdminComponent) {
      component.resetErrorFilter();
    }
  }
}